import { Input, Select, DatePicker, Radio, Mentions } from "antd";
import dayjs from "../../../../utils/dayjs";
import { getFullName } from "../../../../utils/shared";

const SendMessageInput = ({
  message,
  setMessage,
  handleSendMessage,
  disabled,
  question,
  users,
}) => {
  const { type, options = [] } = question || {};

  const renderInput = () => {
    switch (type) {
      case "dropdown":
      case "select":
        return (
          <Select
            value={message || null}
            onChange={(value) => setMessage(value)}
            placeholder="Select an option..."
            options={options.map((value) => ({ value }))}
            disabled={disabled}
            style={{ width: "100%" }}
            className="text-message-input"
          />
        );
      case "boolean":
        return (
          <Radio.Group
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            disabled={disabled}
            className="flex justify-center text-message-input"
          >
            <Radio value={"Yes"}>Yes</Radio>
            <Radio value={"No"}>No</Radio>
          </Radio.Group>
        );
      case "date":
        return (
          <DatePicker
            value={message ? dayjs(message) : null}
            onChange={(date, dateString) => setMessage(dateString || "")}
            placeholder="Select a date..."
            disabled={disabled}
            style={{ width: "100%" }}
            className="text-message-input"
          />
        );

      default:
        return (
          <Input
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
            onPressEnter={(e) => {
              if (!e.shiftKey) {
                e.preventDefault();
                handleSendMessage();
              }
            }}
            type={type || "number"}
            disabled={disabled}
            className="text-message-input"
          />
        );
    }
  };

  return (
    <div style={{ width: "100%" }}>
      {!question ? (
        <Mentions
          value={message}
          onChange={(value) => setMessage(value)}
          placeholder="Type a message..."
          autoSize={{ minRows: 1, maxRows: 4 }}
          onPressEnter={(e) => {
            if (!e.shiftKey) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
          disabled={disabled}
          className="text-message-input"
          options={[
            ...users.map((u) => ({
              value: getFullName(u),
              label: getFullName(u),
            })),
          ]}
        />
      ) : (
        renderInput()
      )}
    </div>
  );
};

export default SendMessageInput;
